import { takeEvery } from "redux-saga/effects";
import {
  processConversion,
  preProcessConversion,
  getConversionStatus,
  getMDLData,
  downLoadMDL,
  getListMultiZip,
  updateConversionStatus,
  startAskingConversionStatus,
  stopAskingConversionStatus,
  showMDLInPatternAssistant,
} from "../actions/actions";
import {
  ProcessConversion,
  PreProcessConversion,
  GetConversionStatus,
  GetMDLData,
  DownLoadMDL,
  GetListMultiZip,
  UpdateConversionStatus,
  StartAskingConversionStatus,
  StopAskingConversionStatus,
  ShowMDLInPatternAssistant,
} from "./conversion";

export default function* conversionsFlow() {
  yield takeEvery(processConversion, ProcessConversion);
  yield takeEvery(preProcessConversion, PreProcessConversion);
  yield takeEvery(getConversionStatus, GetConversionStatus);
  yield takeEvery(getMDLData, GetMDLData);
  yield takeEvery(downLoadMDL, DownLoadMDL);
  yield takeEvery(getListMultiZip, GetListMultiZip);
  yield takeEvery(updateConversionStatus, UpdateConversionStatus);

  yield takeEvery(startAskingConversionStatus, StartAskingConversionStatus);
  yield takeEvery(stopAskingConversionStatus, StopAskingConversionStatus);
  yield takeEvery(showMDLInPatternAssistant, ShowMDLInPatternAssistant);
}
